/* eslint-disable */
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ReactStars from "react-rating-stars-component";
import { axiosInstanceWithToken } from "@/helpers/axios";
import Swal from "sweetalert2";

// Validation schema
const schema = Yup.object().shape({
    reason: Yup.string()
        .required("Comment is required")
        .max(500, "Comment cannot exceed 500 characters"),
    reply: Yup.string()
        .max(500, "Reply cannot exceed 500 characters")
        .notRequired(),
});

const ViewReview = ({
    setIsOpen2,
    selectedId,
    selectedRowStatus,
    type
}) => {
    const [reply, setReply] = useState(false);


    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            reason: "",
            reply: "",
        },
    });

    const {
        id,
        meta_data,
    } = selectedId?.original;

    const parseMetaData = JSON.parse(meta_data);

    const handleClose = () => {
        setIsOpen2(false);
    };


    const handleUpdateReview = async (data) => {
        let formData = new FormData();
        formData.append('meta_data', JSON.stringify({
            ...parseMetaData,
            replies: {
                reply: data?.reply || 'No Reply',
                reason: data?.reason || 'No Reason',
            }
        }));
        formData.append('reply', data?.reply || 'No Reply');
        formData.append('_method', 'PATCH');

        try {
            await axiosInstanceWithToken.post(`/review/${id}`, formData).then((response) => {
                if (response?.data?.status) {
                    Swal.fire({
                        icon: "success",
                        title: "You have successfully replied to the review",
                        showConfirmButton: false,
                        timer: 1500,
                    }).then(() => {
                        handleClose();
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Failed to reply!",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
                handleClose();
            });
        } catch (error) {
            console.error(error?.respomse?.data?.message);
        }
    }


    const onSubmit = (data) => {
        // console.log(data)
        handleUpdateReview(data);

    };

    return (
        <div
            className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50`}
        >
            <div className="bg-white rounded-lg shadow-lg max-w-2xl w-full p-6 h-[400px] overflow-scroll">
                <div className="flex justify-between items center mb-3">
                    <h2 className="text-xl font-semibold mb-4">View Review</h2>
                    <button
                        className="w-8 h-8 mb-2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 flex items-center justify-center"
                        onClick={handleClose}
                    >
                        <i className="fas fa-times text-gray-600"></i>
                    </button>
                </div>
                <div className="grid grid-cols-2 gap-4 mb-4">
                    {[
                        { label: "Overall Satisfaction", value: parseMetaData?.ratings?.Overall_Satisfaction },
                        { label: "Cleanliness", value: parseMetaData?.ratings?.Cleanliness },
                        { label: "Accuracy", value: parseMetaData?.ratings?.Accuracy },
                        { label: "Communication", value: parseMetaData?.ratings?.Communication },
                        { label: "Location", value: parseMetaData?.ratings?.Location },
                        { label: "Check-in", value: parseMetaData?.ratings?.Check_in },
                        { label: "Value", value: parseMetaData?.ratings?.Value },
                    ].map((rating, index) => (
                        <div key={index}>
                            <label className="block text-sm font-medium">{rating.label}</label>
                            <ReactStars
                                count={5}
                                value={rating.value || 0}
                                size={30}
                                activeColor="#ffd700"
                                edit={false}
                            />
                        </div>
                    ))}
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium">Comment</label>
                        <textarea
                            {...register("reason")}
                            rows="3"
                            className={`w-full border rounded-md p-2 focus:outline-none ${errors.reason ? "border-red-500" : "border-gray-300"
                                }`}
                            placeholder="Write your reason..."
                            defaultValue={parseMetaData?.replies?.reason || ''}
                            disabled={parseMetaData?.replies?.reason || type === 'HOST_TO_GUEST'}
                        ></textarea>
                        {errors.reason && (
                            <p className="text-red-500 text-sm">{errors.reason.message}</p>
                        )}
                    </div>
                    {selectedRowStatus !== "No Reply" && (
                        <>
                            <button
                                type="button"
                                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                                onClick={() => setReply(!reply)}
                            >
                                {reply ? "Cancel Reply" : "Reply"}
                            </button>
                        </>
                    )}
                    {reply && (
                        <div>
                            <label className="block text-sm font-medium">Reply</label>
                            <textarea
                                {...register("reply")}
                                rows="3"
                                className={`w-full border rounded-md p-2 focus:outline-none ${errors.reply ? "border-red-500" : "border-gray-300"
                                    }`}
                                defaultValue={parseMetaData?.replies?.reply || ''}
                                placeholder="Write your reply..."
                                disabled={parseMetaData?.replies?.reply || type === 'HOST_TO_GUEST'}
                            ></textarea>
                            {errors.reply && (
                                <p className="text-red-500 text-sm">{errors.reply.message}</p>
                            )}
                        </div>
                    )}
                    <p className="text-xs italic text-gray-600">
                        You can only respond to a review one time. Once you click Submit,
                        your review cannot be retracted. You have a limit of 500 characters
                        for your reply.
                    </p>
                    <div className="flex justify-end gap-4">
                        {selectedRowStatus !== "No Reply" && (
                            <button
                                type="submit"
                                disabled={parseMetaData?.replies?.reply}
                                className="px-4 py-2 bg-[#8ec639] text-white rounded-md hover:bg-green-600"
                            >
                                Submit
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ViewReview;
